/* eslint-disable consistent-return */
import moment from 'moment';
import apiService from 'src/enviroment';
import convertDate from '../utils/formatDate';

const date = moment(new Date()).format('YYYY/MM/DD');

const getTags = async () => {
  const response = await apiService.get('/salesmanago/tags/');
  try {
    if (response.status === 200) {
      return response.data.tags;
    }
  } catch (error) {
    console.error('Error getTags', error);
  }
};

const createTags = async (params) => {
  const body = {
    tag: params.tag,
    fecha_inicio: params.fecha_inicio ? convertDate(params.fecha_inicio) : date,
    fecha_fin: params.fecha_fin ? convertDate(params.fecha_fin) : date,
    estado: params.estado || 'inactivo',
  };
  const response = await apiService.post('/salesmanago/tags/', body);
  try {
    if (response.status === 200 && response.data.success === 1) {
      return true;
    }
  } catch (error) {
    console.error('Error createTags', error);
  }
};

const updateTag = async (params) => {
  const { newData } = params;
  const body = {
    ...newData,
    fecha_inicio: newData.fecha_inicio
      ? convertDate(newData.fecha_inicio)
      : date,
    fecha_fin: newData.fecha_fin ? convertDate(newData.fecha_fin) : date,
  };

  const response = await apiService.put('/salesmanago/tags/', body);
  try {
    if (response.status === 200 && response.data.success === 1) {
      return true;
    }
  } catch (error) {
    console.error('Error updateTag', error);
  }
};

const deleteTag = async (params) => {
  const response = await apiService.delete(`/salesmanago/tags/?id=${params}`);
  try {
    if (response.status === 200 && response.data.success === 1) {
      return response.data.data;
    }
  } catch (error) {
    console.error('Error deleteTag', error);
  }
};

const getScheme = async () => {
  const response = await apiService.get('/salesmanago/esquema/');
  try {
    if (response.status === 200) {
      return response.data.grupos;
    }
  } catch (error) {
    console.error('Error getTags', error);
  }
};

const getFields = async (grupo, tabla, idTag) => {
  const response = await apiService.get(
    `/salesmanago/campos/?grupo=${grupo}&tabla=${tabla}&tag_id=${idTag}`,
  );
  try {
    if (response.status === 200) {
      return response.data.tags;
    }
  } catch (error) {
    console.error('Error getTags', error);
  }
};

const putFields = async (params) => {
  const body = { ...params };
  delete body?.autocompletar;

  const response = await apiService.put('/salesmanago/campos/', body);
  try {
    if (response.status === 200) {
      return response.data.tags;
    }
  } catch (error) {
    console.error('Error getTags', error);
  }
};

const getConfidenceLevel = async (id, level) => {
  const response = await apiService.get(
    `/salesmanago/filtrado/?tag_id=${id}&confianza=${level}`,
  );
  try {
    if (response.status === 200) {
      return response.data.conteo;
    }
  } catch (error) {
    console.error('Error getCondidenceLevel', error);
  }
};

const postSalesManago = async (value) => {
  const body = {
    tag_id: value,
  };
  const response = await apiService.post('/salesmanago/filtrado/', body);
  try {
    if (response.status === 200) {
      return true;
    }
  } catch (error) {
    console.error('Error createTags', error);
  }
};

const countSqlConfidenceLevel = async (id) => {
  const response = await apiService.get(`/salesmanago/actualizar_sql/?tag_id=${id}`);
  try {
    if (response.status === 200) {
      return response.data.conteo;
    }
    return false;
  } catch (error) {
    console.error('errorSendSalesManagoSql');
    return false;
  }
};

const saveSqlQuery = async (id, query) => {
  const body = {
    tag_id: id,
    consulta: query,
  };
  const response = await apiService.put('/salesmanago/actualizar_sql/', body);
  try {
    if (response.status === 200) {
      return true;
    }
  } catch (error) {
    console.error('post');
    return false;
  }
};

const postUsers = async (params) => {
  const body = {
    tag_id: params.id,
    tag_nombre: params.tag,
  };
  const response = await apiService.post('/salesmanago/exportarusuarios/', body);
  try {
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error('post- Id');
    return false;
  }
};

const getCsvUsers = async (params) => {
  const response = await apiService.put('/salesmanago/exportarusuarios/', params);
  try {
    if (response.status === 200) {
      return response.data;
    }
    if (response.status > 300) {
      return false;
    }
  } catch (error) {
    console.error('post- Id');
    return false;
  }
};

const operarTags = async (params) => {
  const body = {
    tag_id: params[0].id,
    tag_A_id: params[1].id,
    tag_B_id: params[2].id,
    operacion: params[3].operacion,
  };
  const response = await apiService.put('/salesmanago/operar_tags/', body);
  try {
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error('post- Id');
    return false;
  }
};

const salesManagoService = {
  getTags,
  createTags,
  updateTag,
  deleteTag,
  getScheme,
  getFields,
  putFields,
  postUsers,
  operarTags,
  getCsvUsers,
  saveSqlQuery,
  postSalesManago,
  getConfidenceLevel,
  countSqlConfidenceLevel,
};

export default salesManagoService;
